import { api, tokenManager, type AuthResponse, type AuthUser } from "../api";

export const authService = {
  async login(email: string, password: string): Promise<AuthResponse> {
    const response = await api.post<AuthResponse>("/auth/login", {
      email,
      password,
    });
    if (response.accessToken) {
      tokenManager.set(response.accessToken);
    }
    return response;
  },

  async getMe(): Promise<AuthUser | null> {
    try {
      if (!this.isAuthenticated()) {
        return null;
      }
      const response = await api.get<{ user: AuthUser }>("/auth/me");
      return response.user;
    } catch (error) {
      tokenManager.clear();
      return null;
    }
  },

  logout() {
    tokenManager.clear();
    window.location.href = "/login";
  },

  isAuthenticated(): boolean {
    return tokenManager.get() !== null;
  },
};
